import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './success.magic.css.js';
import script from './success.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"part":"wrapper"}},[_c('magic-ui-text',{staticClass:"title",attrs:{"tag":"h2","part":"title","data-v-test-id":"account-closure-success-title","content":_vm.$t('account-closure-success.title')}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","data-v-test-id":"account-closure-success-intro","content":_vm.$t('account-closure-success.introduction')}}),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},[_c('magic-ui-link',{attrs:{"button":"","wide":"","variant":"primary","to":_vm.RoutablePage.HOME,"data-v-test-id":"account-closure-success-button"},domProps:{"innerHTML":_vm._s(_vm.$t('account-closure.button'))}})],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-67f12b5f_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-67f12b5f";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
